export const tokens = {
	common: {
		loading: "common.loading",
		close: "common.close",
		cancel: "common.cancel",
		back: "common.back",
		next: "common.next",
		requiredField: "common.requiredField",
		goHome: "common.goHome",
	},
	buyModal: {
		congratulations: "buyModal.congratulations",
		congratulationsDescription: "buyModal.congratulationsDescription",
		ok: "buyModal.ok",
	},
	datePicker: {
		pickDate: "datePicker.pickDate",
	},

	resendTimer: {
		remainingTimeToResend: "resendTimer.remainingTimeToResend",
	},
	tripFinalizeReview: {
		startTripAt: "tripFinalizeReview.startTripAt",
	},
	premiumPlans: {
		buyNow: "premiumPlans.buyNow",
		title: "premiumPlans.title",
		trialDescription: "premiumPlans.trialDescription",
		trialLeft: "premiumPlans.trialLeft",
		upgradeNow: "premiumPlans.upgradeNow",
		use: "premiumPlans.use",
		allPlans: "premiumPlans.allPlans",
		weekly: "premiumPlans.weekly",
		monthly: "premiumPlans.monthly",
		yearly: "premiumPlans.yearly",
		yourCurrentPlan: "premiumPlans.yourCurrentPlan",
		limitedTimeOffer: "premiumPlans.limitedTimeOffer",
	},
	expirePlanModal: {
		description: "expirePlanModal.description",
		viewPlans: "expirePlanModal.viewPlans",
		cancel: "expirePlanModal.cancel",
		yourPlan: "expirePlanModal.yourPlan",
		hasExpired: "expirePlanModal.hasExpired",
	},
	userTypes: {
		driver: "userTypes.driver",
		operator: "userTypes.operator",
		carrier: "userTypes.carrier",
		selfCarrier: "userTypes.selfCarrier",
		manager: "userTypes.manager",
		shipper: "userTypes.shipper",
		broker: "userTypes.broker",
		admin: "userTypes.admin",
		noSelect: "userTypes.noSelect",
	},
	validation: {
		cellphoneLength: "validation.cellphoneLength",
		cellphoneRequired: "validation.cellphoneRequired",
		countryRequired: "validation.countryRequired",
		firstNameRequired: "validation.firstNameRequired",
		lastNameRequired: "validation.lastNameRequired",
		emailRequired: "validation.emailRequired",
		priceRequired: "validation.priceRequired",
		radiusMaximum: "validation.radiusMaximum",
		radiusRequired: "validation.radiusRequired",
		emailInvalid: "validation.emailInvalid",
		cellphoneMaximum: "validation.cellphoneMaximum",
		zipCodeRequired: "validation.zipCodeRequired",
		modelMakeRequired: "validation.modelMakeRequired",
		trailerNumberRequired: "validation.trailerNumberRequired",
		countRequired: "validation.countRequired",
		unCodeRequired: "validation.unCodeRequired",
		totalWeightRequired: "validation.totalWeightRequired",
		lengthRequired: "validation.lengthRequired",
		heightRequired: "validation.heightRequired",
		widthRequired: "validation.widthRequired",
		nameRequired: "validation.nameRequired",
		locationRequired: "validation.locationRequired",
	},

	home: {
		yourTasks: "home.yourTasks",
		stepTitle: "home.stepTitle",
		stepDescription: "home.stepDescription",
		pendingApproval: "home.pendingApproval",
		requestRejected: "home.requestRejected",
		requestAccepted: "home.requestAccepted",
		buttonText: "home.buttonText",
		archiveTab: "home.archiveTab",
		openTab: "home.openTab",
		activeTab: "home.activeTab",
	},
	addTrip: {
		addNewTrip: "addTrip.addNewTrip",
		completeInfoPrompt: "addTrip.completeInfoPrompt",
		completeInfoQuestion: "addTrip.completeInfoQuestion",
		cancel: "addTrip.cancel",
		completeInfo: "addTrip.completeInfo",
		title: "addTrip.title",
		addTrip: "addTrip.addTrip",
	},
	editTrip: {
		title: "editTrip.title",
	},
	trip: {
		startTrip: "trip.startTrip",
		leavingFrom: "trip.leavingFrom",
		startedOn: "trip.startedOn",
		goingTo: "trip.goingTo",
		finalizedMessage: "trip.finalizedMessage",
		loadManagement: "trip.loadManagement",
		realTimeTracking: "trip.realTimeTracking",
		attentions: "trip.attentions",
		hazardous: "trip.hazardous",
		doNotStack: "trip.doNotStack",
		deleteTripTitleOne: "trip.deleteTripTitleOne",
		deleteTripTitleTwo: "trip.deleteTripTitleTwo",
		deleteTripDescription: "trip.deleteTripDescription",
		deleteTripButton: "trip.deleteTripButton",
		trip: "trip.deleteTripTitleOne",
	},
	loadCard: {
		totalLinear: "loadCard.totalLinear",
		pickup: "loadCard.pickup",
		delivery: "loadCard.delivery",
		dueDate: "loadCard.dueDate",
		equipment: "loadCard.equipment",
		price: "loadCard.price",
		totalWeight: "loadCard.totalWeight",
		itemCount: "loadCard.itemCount",
		details: "loadCard.details",
		edit: "loadCard.edit",
	},
	loadDetailCard: {
		totalLinear: "loadDetailCard.totalLinear",
		pickup: "loadDetailCard.pickup",
		delivery: "loadDetailCard.delivery",
		loadItems: "loadDetailCard.loadItems",
		dueDate: "loadDetailCard.dueDate",
		cost: "loadDetailCard.cost",
		equipment: "loadDetailCard.equipment",
		loadItemsAssets: "loadDetailCard.loadItemsAssets",
		totalWeight: "loadDetailCard.totalWeight",
		loadItemsList: "loadDetailCard.loadItemsList",
		hideItems: "loadDetailCard.hideItems",
		showItems: "loadDetailCard.showItems",
		pickupServices: "loadDetailCard.pickupServices",
		dropoffServices: "loadDetailCard.dropoffServices",
	},
	loadItemCard: {
		sizeOf: "loadItemCard.sizeOf",
		weightOf: "loadItemCard.weightOf",
		commodity: "loadItemCard.commodity",
		unCode: "loadItemCard.unCode",
		linearLoad: "loadItemCard.linearLoad",
		length: "loadItemCard.length",
	},
	loadSelectCard: {
		detail: "loadSelectCard.detail",
		deselect: "loadSelectCard.deselect",
		select: "loadSelectCard.select",
	},
	login: {
		title: "login.title",
	},
	loginOtp: {
		verificationCode: "loginOtp.verificationCode",
		weSentTheCode: "loginOtp.weSentTheCode",
		to: "loginOtp.to",
		edit: "loginOtp.edit",
		verify: "loginOtp.verify",
		resendCode: "loginOtp.resendCode",
	},
	loginPhone: {
		logInNow: "loginPhone.logInNow",
		pleaseLoginWithPhone: "loginPhone.pleaseLoginWithPhone",
		phoneNumber: "loginPhone.phoneNumber",
		phoneNumberPlaceholder: "loginPhone.phoneNumberPlaceholder",
		countryCode: "loginPhone.countryCode",
		login: "loginPhone.login",
	},
	loads: {
		archivedTab: "loads.archivedTab",
		waitingForTripTab: "loads.waitingForTripTab",
		addedToTripTab: "loads.addedToTripTab",
		title: "loads.title",
		refresh: "loads.refresh",
		loads: "loads.loads",
		noShipments: "loads.noShipments",
		completeProfile: "loads.completeProfile",
		completeProfileDescription: "loads.completeProfileDescription",
		addLoad: "loads.addLoad",
		emptyLoads: "loads.emptyLoads",
	},
	ignoreLoads: {
		optimizedLoads: "ignoreLoads.optimizedLoads",
		reloadOptimization: "ignoreLoads.reloadOptimization",
		noLoadsFound: "ignoreLoads.noLoadsFound",
		reloadOptimizationText: "ignoreLoads.reloadOptimizationText",
	},
	selectedLoads: {
		loadManagementDescription: "loadSelectCard.loadManagementDescription",

		optimizedLoads: "selectedLoads.optimizedLoads",
		reloadOptimization: "selectedLoads.reloadOptimization",
		noLoadsFound: "selectedLoads.noLoadsFound",
		reloadOptimizationText: "selectedLoads.reloadOptimizationText",
	},
	tripLoads: {
		optimizedLoads: "tripLoads.optimizedLoads",
		reloadOptimization: "tripLoads.reloadOptimization",
		noLoadsFound: "tripLoads.noLoadsFound",
		reloadOptimizationText: "tripLoads.reloadOptimizationText",
	},
	addLoad: {
		loadDetail: "addLoad.loadDetail",
		title: "addLoad.title",
		addLoad: "addLoad.addLoad",
	},
	loadDetail: {
		title: "loadDetail.title",
		deleteLoad: "loadDetail.deleteLoad",
		loadDetail: "loadDetail.loadDetail",
		deleteLoadTitleOne: "loadDetail.deleteLoadTitleOne",
		deleteLoadTitleTwo: "loadDetail.deleteLoadTitleTwo",
		deleteLoadDescription: "loadDetail.deleteLoadDescription",
		deleteLoadButton: "loadDetail.deleteLoadButton",
	},
	loadManagement: {
		title: "loadManagement.title",
		loads: "loadManagement.loads",
		selected: "loadManagement.selected",
		ignored: "loadManagement.ignored",
		optimized: "loadManagement.optimized",
		target: "loadManagement.target",
		reachTargetMessage: "loadManagement.reachTargetMessage",
		viewRouteOverview: "loadManagement.viewRouteOverview",
		finalizeTrip: "loadManagement.finalizeTrip",
		targetNotReached: "loadManagement.targetNotReached",
		congratulations: "loadManagement.congratulations",
		targetReached: "loadManagement.targetReached",
		notMetFinancialTarget: "loadManagement.notMetFinancialTarget",
		metFinancialTarget: "loadManagement.metFinancialTarget",
		ok: "loadManagement.ok",
		cancel: "loadManagement.cancel",
		optimizeModalQuestion: "loadManagement.optimizeModalQuestion",
		exitLoadManagement: "loadManagement.exitLoadManagement",
		addOrEdit: "loadManagement.addOrEdit",
		startTripModalTitle: "loadManagement.startTripModalTitle",
		startTripModalDescriptionOne: "loadManagement.startTripModalDescriptionOne",
		startTripModalDescriptionTwo: "loadManagement.startTripModalDescriptionTwo",
		startTripModalDescriptionThree: "loadManagement.startTripModalDescriptionThree",
		startTripModalSubmit: "loadManagement.startTripModalSubmit",
		startTripModalCancel: "loadManagement.startTripModalCancel",
	},
	driverEdit: {
		title: "driverEdit.title",
	},
	profile: {
		title: "profile.title",
		drivers: "profile.drivers",
		carriers: "profile.carriers",
		trucksTrailer: "profile.trucksTrailer",
		currentCarrier: "profile.currentCarrier",
		logOut: "profile.logOut",
		completeProfile: "profile.completeProfile",
		completeProfileDescription: "profile.completeProfileDescription",
		version: "profile.version",
		upgradePlans: "profile.upgradePlans",
		premiumPlans: "profile.premiumPlans",
		trialPlanDescription: "profile.trialPlanDescription",
		currentPlan: "profile.currentPlan",
	},
	profileEdit: {
		title: "profileEdit.title",
		personal: "profileEdit.personal",
		carrier: "profileEdit.carrier",
	},
	truckEdit: {
		title: "truckEdit.title",
	},
	tracking: {
		title: "tracking.title",
		error: "tracking.error",
		pickupLocationInfo: "tracking.pickupLocationInfo",
		dropOffLocationInfo: "tracking.dropOffLocationInfo",
		estimatedTime: "tracking.estimatedTime",
		cargoOwner: "tracking.cargoOwner",
		doneCurrentStep: "tracking.doneCurrentStep",
		inProgress: "tracking.inProgress",
		tripSteps: "tracking.tripSteps",
		estimatedArrival: "tracking.estimatedArrival",
		startTripAt: "tracking.startTripAt",
		congratulations: "tracking.congratulations",
		tripEnded: "tracking.tripEnded",
		ok: "tracking.ok",
		items: "tracking.items",
	},
	userInformation: {
		carrierTabTitle: "userInformation.carrierTabTitle",
		profileTabTitle: "userInformation.profileTabTitle",
		driverTabTitle: "userInformation.driverTabTitle",
		truckTabTitle: "userInformation.truckTabTitle",
		readyTabTitle: "userInformation.readyTabTitle",
		title: "userInformation.title",
		header: "userInformation.header",
	},
	dashboard: {
		welcome: "dashboard.welcome",
		loads: "dashboard.loads",
		profile: "dashboard.profile",
		loadBoard: "dashboard.loadBoard",
		home: "dashboard.home",
		account: "dashboard.account",
		driver: "dashboard.driver",
	},
	tripChart: {
		target: "tripChart.target",
		weight: "tripChart.weight",
		volume: "tripChart.volume",
		loads: "tripChart.loads",
		totalLinear: "tripChart.totalLinear",
		items: "tripChart.items",
	},
	exitDialog: {
		title: "exitDialog.title",
		leave: "exitDialog.leave",
		tripLeavePrompt: "exitDialog.tripLeavePrompt",
		loadLeavePrompt: "exitDialog.loadLeavePrompt",
		stayButton: "exitDialog.stayButton",
		leaveButton: "exitDialog.leaveButton",
	},
	loadPrice: {
		titleTwo: "loadPrice.titleTwo",
		titleMiddle: "loadPrice.titleMiddle",
		description: "loadPrice.description",
		title: "loadPrice.title",
		subtitle: "loadPrice.subtitle",
		costLabel: "loadPrice.costLabel",
		placeholder: "loadPrice.placeholder",
		loadPriceTitle: "loadPrice.loadPriceTitle",
		ownerInfo: "loadPrice.ownerInfo",
		ownerInfoTitle: "loadPrice.ownerInfoTitle",
		equipmentTitle: "loadPrice.equipmentTitle",
		ownerNameLabel: "routeInfo.ownerNameLabel",
		ownerPhoneNumberLabel: "routeInfo.ownerPhoneNumberLabel",
		ownerEmailLabel: "routeInfo.ownerEmailLabel",
		enterZipCodePlaceholder: "routeInfo.enterZipCodePlaceholder",
		enterOwnerNamePlaceholder: "routeInfo.enterOwnerNamePlaceholder",
		enterEmailPlaceholder: "routeInfo.enterEmailPlaceholder",
		enterOwnerPhoneNumberPlaceholder: "routeInfo.enterOwnerPhoneNumberPlaceholder",
	},
	loadReview: {
		edit: "loadReview.edit",
		title: "loadReview.title",
		subtitle: "loadReview.subtitle",
		pickup: "loadReview.pickup",
		pickupTime: "loadReview.pickupTime",
		dropOff: "loadReview.dropOff",
		dropOffTime: "loadReview.dropOffTime",
		equipment: "loadReview.equipment",
		cost: "loadReview.cost",
		items: "loadReview.items",
		totalWeight: "loadReview.totalWeight",
		totalLinearFeet: "loadReview.totalLinearFeet",
		shipmentDensity: "loadReview.shipmentDensity",
		submit: "loadReview.submit",
		itemDimensionsError: "loadReview.itemDimensionsError",
	},
	homeSteps: {
		step1Title: "homeSteps.step1Title",
		step1Description: "homeSteps.step1Description",
		step1ButtonText: "homeSteps.step1ButtonText",
		step2Title: "homeSteps.step2Title",
		step2Description: "homeSteps.step2Description",
		step2ButtonText: "homeSteps.step2ButtonText",
		step3Title: "homeSteps.step3Title",
		step3Description: "homeSteps.step3Description",
		step3ButtonText: "homeSteps.step3ButtonText",
		step4Title: "homeSteps.step4Title",
		step4Description: "homeSteps.step4Description",
		step4ButtonText: "homeSteps.step4ButtonText",
		step5Title: "homeSteps.step5Title",
		step5Description: "homeSteps.step5Description",
		step5ButtonText: "homeSteps.step5ButtonText",
	},
	tripList: {
		activeTrips: "tripList.activeTrips",
		errorTitle: "tripList.errorTitle",
		errorDescription: "tripList.errorDescription",
		emptyDescription: "tripList.emptyDescription",
	},
	userInfoProfile: {
		completeInfo: "userInfoProfile.completeInfo",
		editLater: "userInfoProfile.editLater",
		requiredField: "userInfoProfile.requiredField",
		nameLabel: "userInfoProfile.nameLabel",
		lastNameLabel: "userInfoProfile.lastNameLabel",
		emailLabel: "userInfoProfile.emailLabel",
		editProfile: "userInfoProfile.editProfile",
		saveNextStep: "userInfoProfile.saveNextStep",
	},
	carrierForm: {
		carrierQuestion: "carrierForm.carrierQuestion",
		requestSent: "carrierForm.requestSent",
		selectCarrier: "carrierForm.selectCarrier",
		requestApproval: "carrierForm.requestApproval",
		waitingApproval: "carrierForm.waitingApproval",
		requestRejected: "carrierForm.requestRejected",
		selectCarrierLabel: "carrierForm.selectCarrierLabel",
		selectRoleLabel: "carrierForm.selectRoleLabel",
		searchPlaceholder: "carrierForm.searchPlaceholder",
		role: "carrierForm.role",
		submitRequest: "carrierForm.submitRequest",
		selfCarrier: "carrierForm.selfCarrier",
		cancelRequest: "carrierForm.cancelRequest",
	},
	driverInfo: {
		addDriverTitle: "driverInfo.addDriverTitle",
		viewAddDriverTitle: "driverInfo.viewAddDriverTitle",
		approvedMessage: "driverInfo.approvedMessage",
		driverDetails: "driverInfo.driverDetails",
		completeLicenseInfo: "driverInfo.completeLicenseInfo",
		viewAddPermissions: "driverInfo.viewAddPermissions",
		driversName: "driverInfo.driversName",
		driversPhoneNumber: "driverInfo.driversPhoneNumber",
		carrierDrivers: "driverInfo.carrierDrivers",
		more: "driverInfo.more",
		addNewDriver: "driverInfo.addNewDriver",
		continue: "driverInfo.continue",
	},

	routeInfo: {
		routeInfoTitleOne: "routeInfo.routeInfoTitleOne",
		routeInfoTitleTwo: "routeInfo.routeInfoTitleTwo",
		routeInfoDescription: "routeInfo.routeInfoDescription",
		requiredFieldNote: "routeInfo.requiredFieldNote",
		pickup: "routeInfo.pickup",
		dropOff: "routeInfo.dropOff",
		zipCodeLabel: "routeInfo.zipCodeLabel",

		nextButtonTitle: "routeInfo.nextButtonTitle",
	},
	dropOffDetails: {
		shipmentDetailsTitle: "dropOffDetails.shipmentDetailsTitle",
		requiredFieldNote: "dropOffDetails.requiredFieldNote",
		zipCodeLabel: "dropOffDetails.zipCodeLabel",
		enterZipCodePlaceholder: "dropOffDetails.enterZipCodePlaceholder",
		nextButtonTitle: "dropOffDetails.nextButtonTitle",
	},
	carrierTrucks: {
		carrierTrucksTitle: "carrierTrucks.carrierTrucksTitle",
		moreButtonTitle: "carrierTrucks.moreButtonTitle",
		addNewTruckButtonTitle: "carrierTrucks.addNewTruckButtonTitle",
		continueButtonTitle: "carrierTrucks.continueButtonTitle",
		driverName: "carrierTrucks.driverName",
		trailerId: "carrierTrucks.trailerId",
	},
	otherDriverForm: {
		phoneNumberLabel: "otherDriverForm.phoneNumberLabel",
		countryCodePlaceholder: "otherDriverForm.countryCodePlaceholder",
		phoneNumberPlaceholder: "otherDriverForm.phoneNumberPlaceholder",
		firstNameLabel: "otherDriverForm.firstNameLabel",
		firstNamePlaceholder: "otherDriverForm.firstNamePlaceholder",
		lastNameLabel: "otherDriverForm.lastNameLabel",
		lastNamePlaceholder: "otherDriverForm.lastNamePlaceholder",
		noteText: "otherDriverForm.noteText",
		editDriverButtonTitle: "otherDriverForm.editDriverButtonTitle",
		saveAndNextButtonTitle: "otherDriverForm.saveAndNextButtonTitle",
	},
	selfDriverForm: {
		licenseNumberLabel: "selfDriverForm.licenseNumberLabel",
		licenseNumberPlaceholder: "selfDriverForm.licenseNumberPlaceholder",
		editDriverButtonTitle: "selfDriverForm.editDriverButtonTitle",
		saveAndNextButtonTitle: "selfDriverForm.saveAndNextButtonTitle",
	},
	trailerInfo: {
		trailerLabel: "trailerInfo.trailerLabel",
		trailerTypeLabel: "trailerInfo.trailerTypeLabel",
		trailerSizeLabel: "trailerInfo.trailerSizeLabel",
		trailerNumberLabel: "trailerInfo.trailerNumberLabel",
		enterTrailerNumberPlaceholder: "trailerInfo.enterTrailerNumberPlaceholder",
		maxCapacityLabel: "trailerInfo.maxCapacityLabel",
		widthLabel: "trailerInfo.widthLabel",
		lengthLabel: "trailerInfo.lengthLabel",
		heightLabel: "trailerInfo.heightLabel",
		editButtonTitle: "trailerInfo.editButtonTitle",
		saveAndNextButtonTitle: "trailerInfo.saveAndNextButtonTitle",
	},

	truckInfo: {
		truckOrTrailerType: "truckInfo.truckOrTrailerType",
		truckLabel: "truckInfo.truckLabel",
		truckIsStraight: "truckInfo.truckIsStraight",
		truckModelMakeLabel: "truckInfo.truckModelMakeLabel",
		enterTruckModelMakePlaceholder: "truckInfo.enterTruckModelMakePlaceholder",
		continueButtonTitle: "truckInfo.continueButtonTitle",
	},
	truckWithoutTrailerInfo: {
		truckLabel: "truckInfo.truckLabel",
		truckIsStraight: "truckInfo.truckIsStraight",
		truckTypeLabel: "truckInfo.truckTypeLabel",
		truckSizeTypeLabel: "truckInfo.truckSizeTypeLabel",
		truckTypePlaceholder: "truckInfo.truckTypePlaceholder",
		truckSizeTypePlaceholder: "truckInfo.truckSizeTypePlaceholder",
		truckModelMakeLabel: "truckInfo.truckModelMakeLabel",
		truckModelMakePlaceholder: "truckInfo.truckModelMakePlaceholder",
		capacityAndDimensionsLabel: "truckInfo.capacityAndDimensionsLabel",
		maximumCapacityLabel: "truckInfo.maximumCapacityLabel",
		widthLabel: "truckInfo.widthLabel",
		lengthLabel: "truckInfo.lengthLabel",
		heightLabel: "truckInfo.heightLabel",
		saveAndNextButton: "truckInfo.saveAndNextButton",
		editButton: "truckInfo.editButton",
	},
	userInfoReady: {
		continue: "userInfoReady.continue",
		congratulations: "userInfoReady.congratulations",
		readyToCreateTrip: "userInfoReady.readyToCreateTrip",
		completedInfo: "userInfoReady.completedInfo",
		createFirstTrip: "userInfoReady.createFirstTrip",
		driver: "userInfoReady.driver",
		driverName: "userInfoReady.driverName",
		truck: "userInfoReady.truck",
		truckModelMake: "userInfoReady.truckModelMake",
		maxCapacity: "userInfoReady.maxCapacity",
		dimensions: "userInfoReady.dimensions",
		trailer: "userInfoReady.trailer",
		trailerNumber: "userInfoReady.trailerNumber",
		trailerType: "userInfoReady.trailerType",
		skip: "userInfoReady.skip",
		letsCreateFirstTrip: "userInfoReady.letsCreateFirstTrip",
	},
	userInfoTruck: {
		titleTruckDetails: "userInfoTruck.titleTruckDetails",
		titleTrailerDetails: "userInfoTruck.titleTrailerDetails",
		titleTruckOrTrailer: "userInfoTruck.titleTruckOrTrailer",
		enterVehicleInfo: "userInfoTruck.enterVehicleInfo",
		viewAddTruck: "userInfoTruck.viewAddTruck",
		selectDriver: "userInfoTruck.selectDriver",
		driver: "userInfoTruck.driver",
		defaultDriver: "userInfoTruck.defaultDriver",
		drivers: "userInfoTruck.drivers",
		continue: "userInfoTruck.continue",
	},
	dropoffServices: {
		additionalServices: "dropoffServices.additionalServices",
		pickupLocation: "dropoffServices.pickupLocation",
		selectServices: "dropoffServices.selectServices",
	},
	pickupServices: {
		additionalServices: "pickupServices.additionalServices",
		pickupLocation: "pickupServices.pickupLocation",
		selectServices: "pickupServices.selectServices",
	},

	loadEquipment: {
		header: "loadEquipment.header",
		subHeader: "loadEquipment.subHeader",
		equipmentLabel: "loadEquipment.equipmentLabel",
		equipmentType: "loadEquipment.equipmentType",
	},
	loadItems: {
		whatItems: "loadItems.whatItems",
		areYouShipping: "loadItems.areYouShipping",
		specifyItems: "loadItems.specifyItems",
		total: "loadItems.total",
		editItem: "loadItems.editItem",
		removeItem: "loadItems.removeItem",
		itemTypeLabel: "loadItems.itemTypeLabel",
		itemTypePlaceholder: "loadItems.itemTypePlaceholder",
		commodityLabel: "loadItems.commodityLabel",
		commodityPlaceholder: "loadItems.commodityPlaceholder",
		countLabel: "loadItems.countLabel",
		linearLabel: "loadItems.linearLabel",
		countPlaceholder: "loadItems.countPlaceholder",
		nonStackableLabel: "loadItems.nonStackableLabel",
		widthLabel: "loadItems.widthLabel",
		widthPlaceholder: "loadItems.widthPlaceholder",
		lengthLabel: "loadItems.lengthLabel",
		lengthPlaceholder: "loadItems.lengthPlaceholder",
		heightLabel: "loadItems.heightLabel",
		heightPlaceholder: "loadItems.heightPlaceholder",
		totalWeightLabel: "losAssets.totalWeightLabel",
		totalWeightPlaceholder: "loadItems.totalWeightPlaceholder",
		hazardousLabel: "loadItems.hazardousLabel",
		unCodeLabel: "loadItems.unCodeLabel",
		unCodePlaceholder: "loadItems.unCodePlaceholder",
		descriptionLabel: "loadItems.descriptionLabel",
		descriptionPlaceholder: "loadItems.descriptionPlaceholder",
		totalWeightRow: "loadItems.totalWeightRow",
		totalLinearFeetRow: "loadItems.totalLinearFeetRow",
		shipmentDensityRow: "loadItems.shipmentDensityRow",
		addAnotherItem: "loadItems.addAnotherItem",
	},
	loadTime: {
		loadTimeTextOne: "loadTime.loadTimeTextOne",
		loadTimeTextTwo: "loadTime.loadTimeTextTwo",
		loadTimeTextThree: "loadTime.loadTimeTextThree",
		loadTimeTextInfo: "loadTime.loadTimeTextInfo",
		pickupTitle: "loadTime.pickupTitle",
		dropOffTitle: "loadTime.dropOffTitle",
		readyForPickUp: "pickup.readyForPickUp",
		requestedInfo: "pickup.requestedInfo",
		requestedLoadingDate: "pickup.requestedLoadingDate",
		rangeFromTime: "pickup.rangeFromTime",
		rangeToTime: "pickup.rangeToTime",
		specificDueDate: "dropoffTime.specificDueDate",
		dueDate: "dropoffTime.dueDate",
		proceedIfNoDueDate: "dropoffTime.proceedIfNoDueDate",
		forDelivery: "dropoffTime.forDelivery",
	},

	tripTime: {
		when: "tripTime.when",
		deportQuestion: "tripTime.deportQuestion",
		dateDescription: "tripTime.dateDescription",
		deportDateLabel: "tripTime.deportDateLabel",
		nextButtonTitle: "tripTime.nextButtonTitle",
	},
	city: {
		label: "city.label",
		placeholder: "city.placeholder",
		selectHeader: "city.selectHeader",
		searchPlaceholder: "city.searchPlaceholder",
	},
	state: {
		label: "state.label",
		placeholder: "state.placeholder",
		selectHeader: "state.selectHeader",
		searchPlaceholder: "state.searchPlaceholder",
	},
	zipCode: {
		label: "zipCode.label",
		placeholder: "zipCode.placeholder",
		selectHeader: "zipCode.selectHeader",
		searchPlaceholder: "zipCode.searchPlaceholder",
		inputError: "zipCode.inputError",
		noZipCodeFound: "zipCode.noZipCodeFound",
	},
	tripTarget: {
		questionPart1: "tripTarget.questionPart1",
		questionPart2: "tripTarget.questionPart2",
		questionPart3: "tripTarget.questionPart3",
		questionPart4: "tripTarget.questionPart4",
		description: "tripTarget.description",
		dateLabel: "tripTarget.dateLabel",
		datePickerLabel: "tripTarget.datePickerLabel",
		placeholder: "tripTarget.placeholder",
		targetLabel: "tripTarget.targetLabel",
		targetInputLabel: "tripTarget.targetInputLabel",
		radiusLabel: "tripTarget.radiusLabel",
		radiusInputLabel: "tripTarget.radiusInputLabel",
		nextButtonTitle: "tripTarget.nextButtonTitle",
	},
	tripReview: {
		leavingFromTitle: "tripReview.leavingFromTitle",
		goingToTitle: "tripReview.goingToTitle",
		startDateTitle: "tripReview.startDateTitle",
		revenueTargetTitle: "tripReview.revenueTargetTitle",
		nextButtonTitle: "tripReview.nextButtonTitle",
		successTitle: "tripReview.successTitle",
		successTitleTwo: "tripReview.successTitleTwo",
		successDescription: "tripReview.successDescription",
		skipButton: "tripReview.skipButton",
		addLoadsButton: "tripReview.addLoadsButton",
	},

	tripDetail: {
		trucksAndDriverQuestion: "tripDetail.trucksAndDriverQuestion",
		trucksAndDriverDescription: "tripDetail.trucksAndDriverDescription",
		truckLabel: "tripDetail.truckLabel",
		selectTruckPlaceholder: "tripDetail.selectTruckPlaceholder",
		selectTruckTitle: "tripDetail.selectTruckTitle",
		errorTitle: "tripDetail.errorTitle",
		driverLabel: "tripDetail.driverLabel",
		selectDriverPlaceholder: "tripDetail.selectDriverPlaceholder",
		trailerLabel: "tripDetail.trailerLabel",
		selectTrailerPlaceholder: "tripDetail.selectTrailerPlaceholder",
		nextButtonTitle: "tripDetail.nextButtonTitle",
	},
	tripRoute: {
		tripName: "tripRoute.tripName",
		addAnotherDestination: "tripRoute.addAnotherDestination",
		whatCityTextPart1: "tripRoute.whatCityTextPart1",
		whatCityTextPart2: "tripRoute.whatCityTextPart2",
		selectCityDescription: "tripRoute.selectCityDescription",
		originConfirmationButton: "tripRoute.originConfirmationButton",
		continueButton: "tripRoute.continueButton",
		originTitle: "tripRoute.originTitle",
		originZipCode: "tripRoute.originZipCode",
		originCity: "tripRoute.originCity",
		destinationTitle: "tripRoute.destinationTitle",
		destinationCity: "tripRoute.destinationCity",
		destinationZipCode: "tripRoute.destinationZipCode",
		routeStep: "tripRoute.routeStep",
		detailsStep: "tripRoute.detailsStep",
		truckStep: "tripRoute.truckStep",
		reviewStep: "tripRoute.reviewStep",
	},
	destinationTrip: {
		whatIsTextPart1: "destinationTrip.whatIsTextPart1",
		whatIsTextPart2: "destinationTrip.whatIsTextPart2",
		selectCityDescription: "destinationTrip.selectCityDescription",
		destinationConfirmationButton: "destinationTrip.destinationConfirmationButton",
		continueButton: "destinationTrip.continueButton",
	},

	//

	loadSteps: {
		routeInfo: "loadSteps.routeInfo",
		details: "loadSteps.details",
		items: "loadSteps.items",
		ready: "loadSteps.ready",
	},
	loadPickupServiceDescriptions: {
		liftGate: "loadPickupServiceDescriptions.liftGate",
		insideLocation: "loadPickupServiceDescriptions.insideLocation",
		limitedAccess: "loadPickupServiceDescriptions.limitedAccess",
		appointmentFree: "loadPickupServiceDescriptions.appointmentFree",
	},
	loadItemTypeDescriptions: {
		pallet: "loadItemTypeDescriptions.pallet",
		skid: "loadItemTypeDescriptions.skid",
		crate: "loadItemTypeDescriptions.crate",
		bag: "loadItemTypeDescriptions.bag",
		bale: "loadItemTypeDescriptions.bale",
		bucket: "loadItemTypeDescriptions.bucket",
		bundle: "loadItemTypeDescriptions.bundle",
		can: "loadItemTypeDescriptions.can",
		carton: "loadItemTypeDescriptions.carton",
		case: "loadItemTypeDescriptions.case",
		coil: "loadItemTypeDescriptions.coil",
		cylinder: "loadItemTypeDescriptions.cylinder",
		drums: "loadItemTypeDescriptions.drums",
		pail: "loadItemTypeDescriptions.pail",
		pieces: "loadItemTypeDescriptions.pieces",
		reel: "loadItemTypeDescriptions.reel",
		roll: "loadItemTypeDescriptions.roll",
		tube: "loadItemTypeDescriptions.tube",
		tote: "loadItemTypeDescriptions.tote",
	},
	payment: {
		failedTitle: "payment.failedTitle",
		failedDescription: "payment.failedDescription",
		successTitle: "payment.successTitle",
		successMessage: "payment.successMessage",
	},
	// dropOffServicesAssets: {
	//   liftGate: "dropOffServicesAssets.liftGate",
	//   pickUpInside: "dropOffServicesAssets.pickUpInside",
	//   limitedAccess: "dropOffServicesAssets.limitedAccess",
	//   appointmentFee: "dropOffServicesAssets.appointmentFee",
	// },
	// pickupServicesAssets: {
	//   liftGate: "pickupServicesAssets.liftGate",
	//   pickUpInside: "pickupServicesAssets.pickUpInside",
	//   limitedAccess: "pickupServicesAssets.limitedAccess",
	//   appointmentFee: "pickupServicesAssets.appointmentFee",
	// },
};
